import { jsx as i } from "react/jsx-runtime";
import o from "./index.es5646.js";
const l = (t, e = 1, f = !1) => {
  if (f)
    return `${t.toFixed(e)}%`;
  const r = Math.abs(t);
  return r >= 1e9 ? `${(t / 1e9).toFixed(e)}B` : r >= 1e6 ? `${(t / 1e6).toFixed(e)}M` : r >= 1e3 ? `${(t / 1e3).toFixed(e)}K` : t.toFixed(e);
}, $ = ({
  value: t,
  enableShortening: e = !1,
  decimalPrecision: f = 1,
  customFormatter: r,
  shouldShowTextWhenNoValue: s = !1,
  noValueText: x = "N/A",
  isPercent: d = !1
}) => {
  if (t == null && s)
    return /* @__PURE__ */ i("div", { className: o.numericCellRoot, children: x });
  let n = (t == null ? void 0 : t.toString()) || "";
  return t != null && (r && typeof r == "function" && (n = r(t)), e && (n = l(t, f, d))), /* @__PURE__ */ i("div", { className: o.numericCellRoot, children: n });
};
export {
  $ as NumericCell
};
//# sourceMappingURL=index.es5535.js.map
